import * as CONSTANTS from '../constants/actions/filters';
import { RESET_PARTS } from '../constants/actions/parts';
import { APPLY_RESET_QUICK_FILTERS } from '../constants/actions/quick-search';

/**
 * @name applyParameters
 * @function
 * @description Applies parameters to the view
 * @param {array} parameters 
 */
export const applyParameters = parameters => {
    return dispatch => dispatch({ type: CONSTANTS.APPLY_PARAMETERS, payload: { parameters } });
}

/**
 * @name applyHash
 * @function
 * @description Sets the provided parameters as active
 * @param {array} modified 
 * @param {array} filters
 */
export const applyHash = ( modified=[], filters=[]) => {
    return dispatch => dispatch({ type: CONSTANTS.APPLY_HASH_CHANGE, payload: { modified, filters } });
}

/**
 * @name resetSort
 * @function
 * @description Clears the sort values from all columns
 * @param {string} parameter 
 */
export const resetSort = parameter => {
    return dispatch => dispatch({ type: CONSTANTS.RESET_SORT, payload: { parameter } });
}
/**
 * @name resetColumn
 * @function
 * @description Clears the Column filter values
 * @param {string} parameter 
 */
export const resetColumn = (value, parameter) => {
    return dispatch => dispatch({ type: CONSTANTS.RESET_COLUMN, payload: { value, parameter } });
}
/**
 * @name hideParameter
 * @function 
 * @description toggles comparison of parts
 * @param {number|string} parameter the parameter to hide
 */
export const hideParameter = parameter => {
    return dispatch => dispatch({ type: CONSTANTS.HIDE_PARAMETER, payload: { parameter } });
}

/**
 * @name reorder
 * @function 
 * @description Reorders the parameters
 * @param {number|string} subject Parameter being moved
 * @param {number|string} target Parameter that `subject` is being moved next to
 * @param {string} [side=left|right] Side of `target` that `subject` is being moved to
 */
export const reorder = ( subject, target, side ) => {
    return dispatch => dispatch({ type: CONSTANTS.REORDER, payload: { subject, target, side } });
}

/**
 * @name setTooltip
 * @function
 * @description Sets the hover tooltip for a parameter
 * @param {Object} coords 
 * @param {string} label 
 * @param {boolean} display
 */
export const setTooltip = ( coords, label, display ) => {
    return dispatch => dispatch({ type: CONSTANTS.SET_TOOLTIP, payload: { coords, label, display } });
}

/**
 * @name prioritizeParameter
 * @function 
 * @description displays a parameter and brings it to the front
 * @param {string} parameter
 * @param {boolean} show
 */
export const prioritizeParameter = ( parameter, show ) => {
    return dispatch => dispatch({ type: CONSTANTS.PRIORITIZE_PARAMETER, payload: { parameter, show } });
}

/**
 * @name sortByColumn
 * @function
 * @param {string} column - column to be sorted by
 * @param {string} order - direction the column should be sorted by. "asc" for ascending or "desc" for descending
 * @param {boolean} addToCurrentSort - determines if provided sort should be added to (true) or replace the existing sort (false)
 * @param {array} currentPriority - the current sort criterion
 * @description Allows user to sort the provided data by the provided column
 */
export const sortByColumn = ( column, order, addToCurrentSort, currentPriority ) => {
    return dispatch => dispatch({ type: CONSTANTS.SORT_BY_COLUMN, payload: { column, order, addToCurrentSort, currentPriority } });
}

/**
* @name resetDetails
* @function 
* @description Reset details value
* @param {boolean} resetDetails 
*/
export const resetDetails = ( resetValue ) => {
   return dispatch => dispatch({ type: CONSTANTS.RESET_DETAILS, payload: { resetValue } });
}

/**
* @name resetAll
* @function 
* @description Reset table 
*/
export const resetAll = () => {
    return dispatch => {
        dispatch({ type: CONSTANTS.RESET_PARAMETERS });
        dispatch({ type: RESET_PARTS });
    }
 }
 
/**
* @name resetQuickFilters
* @function 
* @description Reset quick filters
* @param {boolean} isResetedBool 
*/
 export const resetQuickFilters = (isResetedBool) => {
     return dispatch => {
         dispatch({type: APPLY_RESET_QUICK_FILTERS,
            payload: {
              isReseted: isResetedBool,
            }})
     }
  };

 /**
* @name UPDATE_DEFAULT_PARAMETERS
* @function 
* @description Reset table 
*/
export const updateDefaultParameters = (parameterIds, newDefaultValue) => {
    return dispatch => {
        dispatch({ type: CONSTANTS.UPDATE_DEFAULT_PARAMETERS, payload:{parameterIds, newDefaultValue} });
    }
 }